var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #007878;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "garbage_disposer",
    "data-name": "garbage disposer"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m150,45.68v41.34c0,3.98-3.21,7.21-7.16,7.21h-1.14c.04.33.07.65.07.99v70.68c0,5.27-3.76,9.72-8.8,10.69v.35c0,5.05-4.1,9.15-9.15,9.15H56.19c-5.05,0-9.16-4.1-9.16-9.15v-.35c-5.04-.98-8.8-5.42-8.8-10.69v-70.68c0-.34.02-.66.07-.99h-1.14c-3.95,0-7.16-3.24-7.16-7.21v-41.34c0-3.98,3.21-7.21,7.16-7.21h105.67c3.95,0,7.16,3.23,7.16,7.21Zm-15.1-30.36c1.4,0,2.54-1.14,2.54-2.54v-6.35c0-1.4-1.14-2.54-2.54-2.54H45.1c-1.4,0-2.54,1.14-2.54,2.54v6.35c0,1.4,1.14,2.54,2.54,2.54h4.62v9.44h-4.62c-1.4,0-2.54,1.14-2.54,2.54v6.34c0,1.4,1.14,2.54,2.54,2.54h89.8c1.4,0,2.54-1.13,2.54-2.54v-6.34c0-1.4-1.14-2.54-2.54-2.54h-4.62v-9.44h4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m48.78,170.62h82.44c2.47-.17,4.39-2.23,4.39-4.73v-70.67c0-.58-.47-1.05-1.05-1.05H45.44c-.58,0-1.05.47-1.05,1.05v70.67c0,2.49,1.92,4.55,4.39,4.73Zm-11.62-126c-.56,0-1.01.47-1.01,1.05v41.34c0,.58.45,1.05,1.01,1.05h105.67c.56,0,1.01-.47,1.01-1.05v-41.34c0-.58-.45-1.05-1.01-1.05H37.16Zm12.95,132.53c.11,3.25,2.79,5.86,6.07,5.86h67.62c3.28,0,5.96-2.61,6.07-5.86H50.12ZM45.64,12.25h88.72v-5.27H45.64v5.27Zm0,20.86h88.72v-5.27H45.64v5.27Zm7.15-8.34h74.41v-9.44H52.79v9.44Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA5);
export default __webpack_public_path__ + "static/media/a5.70daef6bd359c93b7402e4e3fbac6234.svg";
export { ForwardRef as ReactComponent };